import { useNavigate } from "react-router-dom";
import { Table2 } from "../../../../../components/Table2/Table2";
import { feeshudulefunctions } from "../../feeshudulefunctions";
import { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";

const Tablecoloum = [
  {
    title: "Selection",
    Selectionbool: true,
  },
  {
    title: "Location",
  },
];

const Tablecoloum2 = [
  {
    title: "Location",
  },
];

export const Entities = ({
  EntitiesTabledata,
  isEditableButton,
  aftersave,
  EntitiesTabledata2,
  setentitidata,
  setEntitiesTabledata,
  entitidata
}) => {
  const navigate = useNavigate();
  const clas = new feeshudulefunctions();
  const [loading, setLoading] = useState(false);
  const [input, setinput] = useState();

  useEffect(() => {
    clas.getEntitiesTableData(setEntitiesTabledata, setLoading, navigate);
  }, [isEditableButton, aftersave]);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      {isEditableButton && (
        <div
          style={{ width: "35%", alignItems: "center" }}
          className="Notes_serch_block"
        >
          <p style={{ fontWeight: "bold" }}>Search Entities</p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (input) {
                clas.getEntitiesTablefind(
                  setEntitiesTabledata,
                  setLoading,
                  navigate,
                  input
                );
              } else {
                clas.getEntitiesTableData(
                  setEntitiesTabledata,
                  setLoading,
                  navigate
                );
              }
            }}
          >
            <input
              type="text"
              onChange={(e) => {
                setinput(e.target.value);
              }}
            />
          </form>

          <button
            style={{
              backgroundColor: "var(--button2)",
              color: "white",
              justifyContent: "space-around",
              display: "flex",
              width: "95px",
              height: "40px",
            }}
            onClick={() => {
              if (input) {
                clas.getEntitiesTablefind(
                  setEntitiesTabledata,
                  setLoading,
                  navigate,
                  input
                );
              } else {
                clas.getEntitiesTableData(
                  setEntitiesTabledata,
                  setLoading,
                  navigate
                );
              }
            }}
          >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
              }}
            >
              Search
            </p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5006 11.0006H11.7106L11.4306 10.7306C12.6306 9.33063 13.2506 7.42063 12.9106 5.39063C12.4406 2.61063 10.1206 0.390626 7.32063 0.0506256C3.09063 -0.469374 -0.469374 3.09063 0.0506256 7.32063C0.390626 10.1206 2.61063 12.4406 5.39063 12.9106C7.42063 13.2506 9.33063 12.6306 10.7306 11.4306L11.0006 11.7106V12.5006L15.2506 16.7506C15.6606 17.1606 16.3306 17.1606 16.7406 16.7506C17.1506 16.3406 17.1506 15.6706 16.7406 15.2606L12.5006 11.0006ZM6.50063 11.0006C4.01063 11.0006 2.00063 8.99063 2.00063 6.50063C2.00063 4.01063 4.01063 2.00063 6.50063 2.00063C8.99063 2.00063 11.0006 4.01063 11.0006 6.50063C11.0006 8.99063 8.99063 11.0006 6.50063 11.0006Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      )}
      <div style={{ marginTop: "1%" }}>
        <Table2
          Tablecoloum={isEditableButton ? Tablecoloum : Tablecoloum2}
          tableRow={isEditableButton ? EntitiesTabledata : EntitiesTabledata2}
          editTable={false}
          load={false}
          coloumWidthText={"feesheduleTable"}
          height={"auto"}
          mandatoryColoum={"Location"}
          showTotalBlock={false}
          setentitidata={setentitidata}
          entitidata={entitidata}
        />
      </div>
    </>
  );
};
